import React, { useState } from "react";
// import Stock from './StockCount.js'
export default function HeaderName({ setIsSidebarOpen, isSidebarOpen }) {
  const [hide, setHide] = useState(false);

  const divStyles1 = {
    textShadow: "1px 1px 2px grey",
    margin: "auto 200px",
  };

  const handleHide = () => {
    setHide(!hide);
  };
  const Role = localStorage.getItem("role");
  return (
    <nav className="navbar navbar-expand navbar-white navbar-light">
      {/* <!-- Left navbar links --> */}
      {/* <ul className='navbar-nav text-lg-end mr-2 mt-2'>
        <li className='nav-item' onClick={handleHide}>
          <i className='fas fa-bars'></i>
        </li>
      </ul> */}
      <div className="flex col-1 rounded">
        {!isSidebarOpen && (
          <button
            onClick={() => setIsSidebarOpen(true)}
            className="btn btn-link p-2 ms-3 text-dark"
          >
            <i className="fas fa-align-left fs-5"></i>
          </button>
        )}
      </div>
      {/* <Stock setHide={setHide} hide={hide} /> */}
      {Role === "stockController" ? (
        <div className="title py-3">
          <h3 className={isSidebarOpen ? "header-title" : "header-title-close"}>
            Stock Controller
          </h3>
        </div>
      ) : (
        <div className="title py-3">
          <h3 className={isSidebarOpen ? "header-title" : "header-title-close"}>
            Finance & Admin Module
          </h3>
        </div>
      )}

      <ul className="navbar-nav ml-auto"></ul>
    </nav>
  );
}
